module.exports = __webpack_public_path__ + "img/bg4.25ffaa67.png";